module.exports = __webpack_public_path__ + "1a55247672a356cc974cef6ac4d2df52.png";